export const STUDENT_BADGES_DEFAULT_BRANCH_ID = 'default';

export const COLLECTIONS = {
    OWNERS: 'owners',
    TENANTS: 'tenants',
    TENANT_USERS: 'tenant_users',
    PLANS: 'plans',
    STAFF: 'staff',
    STAFF_LOOKUP: 'staff_lookup',
    STUDENTS_ROOT: 'Students',
    STUDENTS: 'students',
    TEACHERS_ROOT: 'Teachers',
    TEACHERS: 'teachers',
    ATTENDANCE: 'attendance',
    FINANCE_ACCOUNTS: 'financeAccounts',
    FINANCE_ENTRIES: 'financeEntries',
    FINANCE_ANALYTICS: 'financeAnalytics',
    FEE_CHARGES: 'feeCharges',
    FEE_CHARGE_HISTORY: 'feeChargeHistory',
    STUDENT_FEE_PAYMENTS: 'studentFeePayments',
    NOTICES_ANNOUNCEMENTS: 'noticesAnnouncements',
    NOTIFICATIONS: 'notifications',
    /** Campus schedules + analytics root (see `schoolTime/{tenantId}/branches/{branchId}`). */
    SCHOOL_TIME: 'schoolTime',
    /** Student badges per campus: `studentBadges/{tenantId}/branches/{branchId}` + `items` subcollection. */
    STUDENT_BADGES: 'studentBadges',
    /** Classes (tenant root doc + `items` subcollection), like notifications. */
    TENANT_CLASSES: 'tenantClasses',
    /** Subjects (tenant root doc + `items` subcollection). */
    TENANT_SUBJECTS: 'tenantSubjects',
    HOMEWORKS: 'homeworks',
    APP_SETTINGS: 'appSettings',
    /** Platform-level module catalogue (owner-managed). */
    MODULES: 'modules',
    TIMETABLES: 'timetables',
};

export const ownerDocPath = (uid) => `${COLLECTIONS.OWNERS}/${uid}`;
export const tenantDocPath = (tenantId) => `${COLLECTIONS.TENANTS}/${tenantId}`;

// staff/{tenantId}/staff/{staffId}
export const staffDocPath = (tenantId, staffId) => `${COLLECTIONS.STAFF}/${tenantId}/${COLLECTIONS.STAFF}/${staffId}`;

// staff_lookup/{uid}
export const staffLookupDocPath = (uid) => `${COLLECTIONS.STAFF_LOOKUP}/${uid}`;

// Students/{tenantId}
export const tenantStudentsRootDocPath = (tenantId) => `${COLLECTIONS.STUDENTS_ROOT}/${tenantId}`;
// Students/{tenantId}/students/{studentId}
export const studentDocPath = (tenantId, studentId) =>
    `${COLLECTIONS.STUDENTS_ROOT}/${tenantId}/${COLLECTIONS.STUDENTS}/${studentId}`;

// Teachers/{tenantId}/teachers/{teacherId}
export const teacherDocPath = (tenantId, teacherId) =>
    `${COLLECTIONS.TEACHERS_ROOT}/${tenantId}/${COLLECTIONS.TEACHERS}/${teacherId}`;

// attendance/{tenantId}/{scope}/{monthKey}/entries/{entryId}
export const attendanceEntryDocPath = ({ tenantId, scope, monthKey, entryId }) =>
    `${COLLECTIONS.ATTENDANCE}/${tenantId}/${scope}/${monthKey}/entries/${entryId}`;

// tenants/{tenantId}/financeAccounts/{accountId}
export const financeAccountDocPath = (tenantId, accountId) =>
    `${COLLECTIONS.TENANTS}/${tenantId}/${COLLECTIONS.FINANCE_ACCOUNTS}/${accountId}`;

// tenants/{tenantId}/financeEntries/{entryId}
export const financeEntryDocPath = (tenantId, entryId) =>
    `${COLLECTIONS.TENANTS}/${tenantId}/${COLLECTIONS.FINANCE_ENTRIES}/${entryId}`;

// tenants/{tenantId}/financeAnalytics/summary
export const financeSummaryDocPath = (tenantId) =>
    `${COLLECTIONS.TENANTS}/${tenantId}/${COLLECTIONS.FINANCE_ANALYTICS}/summary`;

// tenants/{tenantId}/feeCharges/{chargeId}
export const feeChargeDocPath = (tenantId, chargeId) =>
    `${COLLECTIONS.TENANTS}/${tenantId}/${COLLECTIONS.FEE_CHARGES}/${chargeId}`;

// noticesAnnouncements/{tenantId}/{noticeType}/{noticeId}
export const noticeDocPath = (tenantId, noticeType, noticeId) =>
    `${COLLECTIONS.NOTICES_ANNOUNCEMENTS}/${tenantId}/${noticeType}/${noticeId}`;

// notifications/{tenantId}/items/{notificationId}
export const notificationDocPath = (tenantId, notificationId) =>
    `${COLLECTIONS.NOTIFICATIONS}/${tenantId}/items/${notificationId}`;

// schoolTime/{tenantId} — summary / analytics for school time & campuses
export const schoolTimeSummaryDocPath = (tenantId) => `${COLLECTIONS.SCHOOL_TIME}/${tenantId}`;

// schoolTime/{tenantId}/branches/{branchId} — one campus (name, address, schedule, effectiveFrom)
export const schoolTimeBranchDocPath = (tenantId, branchId) =>
    `${COLLECTIONS.SCHOOL_TIME}/${tenantId}/branches/${branchId}`;

// studentBadges/{tenantId}/branches/{branchId} — per-campus badge analytics (mirrors schoolTime branch ids)
export const studentBadgesBranchDocPath = (tenantId, branchId) =>
    `${COLLECTIONS.STUDENT_BADGES}/${tenantId}/branches/${branchId}`;

// studentBadges/{tenantId}/branches/{branchId}/items/{badgeId} — one cohort badge for that campus
export const studentBadgeItemDocPath = (tenantId, branchId, badgeId) =>
    `${COLLECTIONS.STUDENT_BADGES}/${tenantId}/branches/${branchId}/items/${badgeId}`;

/** @deprecated Legacy flat path before per-branch badges. */
export const studentBadgeLegacyItemDocPath = (tenantId, badgeId) =>
    `${COLLECTIONS.STUDENT_BADGES}/${tenantId}/items/${badgeId}`;

// tenantClasses/{tenantId} — class analytics summary
export const tenantClassesSummaryDocPath = (tenantId) => `${COLLECTIONS.TENANT_CLASSES}/${tenantId}`;

// tenantClasses/{tenantId}/items/{classId}
export const tenantClassItemDocPath = (tenantId, classId) =>
    `${COLLECTIONS.TENANT_CLASSES}/${tenantId}/items/${classId}`;

// tenantSubjects/{tenantId} — subject analytics summary
export const tenantSubjectsSummaryDocPath = (tenantId) => `${COLLECTIONS.TENANT_SUBJECTS}/${tenantId}`;

// tenantSubjects/{tenantId}/items/{subjectId}
export const tenantSubjectItemDocPath = (tenantId, subjectId) =>
    `${COLLECTIONS.TENANT_SUBJECTS}/${tenantId}/items/${subjectId}`;

// timetables/{tenantId}/classes/{classId}
export const tenantClassTimetableDocPath = (tenantId, classId) =>
    `${COLLECTIONS.TIMETABLES}/${tenantId}/classes/${classId}`;
